function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1685 4730 c-39 -12 -511 -302 -549 -337 -57 -53 -56 -46 -56 -635 0 -499 2 -545 18 -564 50 -63 146 -58 184 9 10 17 14 148 18 532 l5 510 200 122 c110 67 203 123 208 123 4 0 7 -387 7 -860 l0 -860 -280 0 c-302 0 -322 -3 -349 -52 -10 -19 -12 -131 -9 -529 l4 -504 31 -116 c81 -304 216 -536 429 -739 282 -267 641 -410 1031 -410 413 0 780 153 1068 445 364 369 511 897 390 1403 -139 579 -614 1025 -1200 1127 -49 9 -173 19 -275 22 -163 5 -190 4 -222 -11 -36 -18 -68 -65 -68 -103 0 -24 34 -79 57 -91 10 -5 101 -12 203 -15 283 -8 448 -46 638 -148 349 -186 581 -494 664 -882 28 -132 30 -350 5 -479 -52 -264 -166 -478 -356 -669 -251 -252 -554 -379 -906 -379 -451 0 -861 234 -1097 626 -59 97 -111 224 -146 352 -26 96 -26 100 -30 515 l-3 417 210 0 211 0 0 -342 c0 -359 7 -441 42 -548 114 -350 417 -580 783 -595 239 -9 445 68 619 235 132 126 206 255 246 433 19 83 22 116 17 220 -6 138 -28 229 -82 337 -90 184 -217 309 -400 396 -163 77 -162 77 -607 81 l-398 4 -2 918 -3 917 -28 42 c-44 67 -147 105 -222 82z m1093 -2212 c101 -37 172 -82 245 -155 117 -118 175 -246 184 -409 11 -186 -52 -350 -187 -485 -336 -337 -901 -194 -1051 266 -22 67 -23 86 -27 443 l-3 373 383 -3 383 -3 73 -27z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2549 2090 c-145 -25 -200 -202 -93 -302 61 -57 144 -64 215 -19 56 35 79 81 79 154 0 109 -93 186 -201 167z"
}));

const SvgBugsnag = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "512.000000pt",
  height: "512.000000pt",
  viewBox: "0 0 512.000000 512.000000",
  preserveAspectRatio: "xMidYMid meet",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBugsnag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bugsnag.7e057f85.svg";
export { ForwardRef as ReactComponent };